import React from 'react';
import { Chip, ChipProps, styled } from "@mui/material";

export interface PillProps extends Omit<ChipProps, 'onDelete'> { }

const CustomChip = styled(Chip)(() => ({
    '&.MuiChip-root': {
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: '50px',
        borderBottomRightRadius: '25px',
        borderTopRightRadius: '25px',
        height: '19.5px'
    }
}));

export const Pill = ({ 
    sx,
    ...props 
}: PillProps) => {

    return (
            <CustomChip 
                sx={{ 
                    color: '#000', 
                    ...sx
                }} 
                {...props}
            />
    )
}